import { frontendURL } from '../../../../helper/URLHelper';
import { parseBoolean } from '@chatwoot/utils';
import store from '../../../../store';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { WEB_ORDER_ACCESS_PERMISSIONS } from 'dashboard/constants/permissions';

import ProfileWrapper from './Wrapper.vue';
import AgentHubLayout from './AgentHubLayout.vue';
import AgentHubGeneralTab from './AgentHubGeneralTab.vue';
import AgentHubSecurityTab from './AgentHubSecurityTab.vue';
import AgentHubNotificationsTab from './AgentHubNotificationsTab.vue';
import AgentHubReportsTab from './AgentHubReportsTab.vue';
import AgentHubOverviewTab from './AgentHubOverviewTab.vue';
import MfaSettings from './MfaSettings.vue';

const profileMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

const webOrderMeta = {
  permissions: [
    'administrator',
    ...WEB_ORDER_ACCESS_PERMISSIONS,
    'integration_manage',
  ],
};

const adminPermissionsMeta = {
  featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
  permissions: ['administrator'],
};

const ownReportsMeta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage', 'report_own'],
};

const memberReportsMeta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage', 'report_agents'],
};

const redirectWhenMfaDisabled = (to, from, next) => {
  if (!parseBoolean(window.chatwootConfig?.isMfaEnabled)) {
    next({ name: 'profile_settings_index' });
    return;
  }
  next();
};

const myHubNameForSelf = to => {
  if (to.name === 'profile_member_web_order') return 'profile_web_order';
  if (to.name === 'profile_member_permissions') return 'profile_permissions';
  if (to.name === 'profile_member_reports') return 'profile_reports';
  return 'profile_settings_index';
};

const redirectSelfMemberToMyHub = (to, from, next) => {
  const currentId = store.getters.getCurrentUserID;
  if (currentId && String(to.params.userId) === String(currentId)) {
    next({
      name: myHubNameForSelf(to),
      params: { accountId: to.params.accountId },
      replace: true,
    });
    return;
  }
  next();
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/profile'),
      name: 'profile_settings',
      meta: profileMeta,
      component: ProfileWrapper,
      children: [
        {
          path: '',
          component: AgentHubLayout,
          meta: profileMeta,
          children: [
            {
              path: '',
              redirect: { name: 'profile_settings_index' },
            },
            {
              path: 'settings',
              name: 'profile_settings_index',
              component: AgentHubGeneralTab,
              meta: profileMeta,
            },
            {
              path: 'security',
              name: 'profile_settings_security',
              component: AgentHubSecurityTab,
              meta: profileMeta,
            },
            {
              path: 'mfa',
              name: 'profile_settings_mfa',
              component: MfaSettings,
              meta: profileMeta,
              beforeEnter: redirectWhenMfaDisabled,
            },
            {
              path: 'notifications',
              name: 'profile_settings_notifications',
              component: AgentHubNotificationsTab,
              meta: profileMeta,
            },
            {
              path: 'web-order',
              name: 'profile_web_order',
              component: () =>
                import('../../webOrder/pages/WebOrderAgentOpsTab.vue'),
              meta: webOrderMeta,
            },
            {
              path: 'agent-integration',
              name: 'profile_agent_integration',
              meta: webOrderMeta,
              redirect: { name: 'profile_web_order' },
            },
            {
              path: 'permissions',
              name: 'profile_permissions',
              component: () => import('../agents/AgentPermissionsTab.vue'),
              meta: adminPermissionsMeta,
            },
            {
              path: 'reports',
              name: 'profile_reports',
              component: AgentHubReportsTab,
              meta: ownReportsMeta,
            },
          ],
        },
        {
          path: 'members/:userId',
          component: AgentHubLayout,
          meta: profileMeta,
          beforeEnter: redirectSelfMemberToMyHub,
          children: [
            {
              path: '',
              name: 'profile_member_overview',
              component: AgentHubOverviewTab,
              meta: profileMeta,
            },
            {
              path: 'web-order',
              name: 'profile_member_web_order',
              component: () =>
                import('../../webOrder/pages/WebOrderAgentOpsTab.vue'),
              meta: webOrderMeta,
            },
            {
              path: 'permissions',
              name: 'profile_member_permissions',
              component: () => import('../agents/AgentPermissionsTab.vue'),
              meta: adminPermissionsMeta,
            },
            {
              path: 'reports',
              name: 'profile_member_reports',
              component: AgentHubReportsTab,
              meta: memberReportsMeta,
            },
          ],
        },
      ],
    },
  ],
};
